<template>
    <v-dialog
        :value="isOpen"
        max-width="500px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    <template v-if="!isNewProductionProcess">
                        Edycja procesu produkcyjnego <strong>{{ productionProcess.name }}</strong>
                    </template>
                    <template v-else>
                        Tworzenie procesu produkcyjnego
                    </template>
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <v-text-field
                    v-model="name"
                    label="Nazwa"
                    :error-messages="productionProcessNameErrors"
                    required
                />
                <v-autocomplete
                    v-model="productProductionPropertyValue"
                    :items="productProductionPropertyValues"
                    :search-input.sync="search"
                    no-data-text="Nie znaleziono cech produkcyjnych"
                    label="Cechy produkcyjne:"
                    placeholder="Wybierz cechy produkcyjne"
                    item-value="id"
                    item-text="productProductionPropertyName"
                    chips
                    clearable
                    multiple
                    @change="search = null"
                >
                    <template #selection="data">
                        <v-chip
                            close
                            @update:active="removeProperty(data.item)"
                        >
                            {{ data.item.value }} ({{ data.item.productProductionProperty.name }})
                        </v-chip>
                    </template>
                    <template #item="data">
                        {{ data.item.value }} ({{ data.item.productProductionProperty.name }})
                    </template>
                </v-autocomplete>
                <v-select
                    v-model="productionCode"
                    label="kod produkcyjny"
                    :items="steps"
                    item-text="step_code"
                    item-value="step_code"
                    :error-messages="productionCodeErrors"
                    required
                />
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    :disabled="actionLoading"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>

                <v-spacer />

                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    :loading="actionLoading"
                    @click="saveProductionProcess"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { isEmpty } from 'lodash'
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'SaveProductionProcessDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        productionProcess: {
            type: Object,
            default: null
        },
        productProductionPropertyValues: {
            type: Array,
            default: () => []
        },
        steps: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            name: null,
            productProductionPropertyValue: [],
            productionCode: null,
            actionLoading: false,
            search: null
        }
    },
    validations() {
        return {
            name: {
                required
            },
            productionCode: {
                required
            }
        }
    },
    computed: {
        isNewProductionProcess() {
            return isEmpty(this.productionProcess)
        },
        // Walidacje
        productionProcessNameErrors() {
            const errors = []

            if (!this.$v.name.$dirty) return errors
            !this.$v.name.required && errors.push('Proszę podać nazwę procesu produkcyjnego.')

            return errors
        },
        productionCodeErrors() {
            const errors = []

            if (!this.$v.productionCode.$dirty) return errors
            !this.$v.productionCode.required && errors.push('Proszę wybrać kod produkcyjny.')

            return errors
        },
    },
    watch: {
        productionProcess(value) {
            if (!isEmpty(value)) {
                this.name = value.name
                this.productProductionPropertyValue = value.productProductionPropertyValue
                this.productionCode = value.productionCode
            }
        }
    },
    methods: {
        saveProductionProcess() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })
            } else {
                let action = null
                const payload = {
                    name: this.name,
                    productProductionPropertyValue: this.productProductionPropertyValue || [],
                    productionCode: this.productionCode
                }

                if (this.isNewProductionProcess) {
                    action = 'createProductionProcess'
                } else {
                    action = 'updateProductionProcess'
                    payload.id = this.productionProcess.id
                }

                this.actionLoading = true
                this.$store.dispatch(`configurations/${action}`, payload)
                    .then(() => {
                        this.$emit('on-save')
                        this.$v.$reset()
                    })
                    .catch(error => {
                        errorHandler(error)
                    })
                    .finally(() => {
                        this.actionLoading = false
                        this.onClose()
                    })
            }
        },
        onClose() {
            setTimeout(() => {
                this.name = null
                this.productProductionPropertyValue = []
                this.$v.$reset()
            }, 500)

            this.$emit('on-close')
        },
        removeProperty(item) {
            this.productProductionPropertyValue.splice(this.productProductionPropertyValue.indexOf(item), 1)
        }
    }
}
</script>

